import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function VerificacionCompleta() {
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const reservationId = params.get("reservation_id");
  const originUrl = params.get("origin_url") || window.location.origin;

  useEffect(() => {
    if (!reservationId) {
      setError("Falta reservation_id");
      return;
    }
    axios
      .get(`/api/checkout/session/${reservationId}/pay`, { params: { origin_url: originUrl } })
      .then((r) => {
        window.location.href = r.data.url;
      })
      .catch((err) => {
        setError(err?.response?.data?.detail || "Verificación pendiente o rechazada");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId]);

  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center">
      {error ? (
        <p className="text-red-600">{error}</p>
      ) : (
        <p>Confirmando tu verificación...</p>
      )}
    </div>
  );
}
